import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from "../services/user.service";
//import {ToastrService} from "ngx-toastr/ngx-toastr"; // not need for ngx-toastr?

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Nestas';

  private viewContaineRef:ViewContainerRef;

  constructor(private _user:UserService, public translate:TranslateService, /*public toasterManager:ToastrService, */private _vRef:ViewContainerRef) {
    this.viewContaineRef = _vRef;
    //this.toasterManager.setRootViewContainerRef(_vRef);
  }

  ngOnInit() {
    var userLang = this._user.me['lang'] || 'nl';
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('nl');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(userLang);
    document.documentElement.setAttribute("lang", userLang);
  }
}
